import { Helmet } from "react-helmet-async";
import { Layout } from "@/components/layout/Layout";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";

const faqs = [
  { q: "How far in advance should we book?", a: "We recommend booking 8-12 months in advance, especially for peak season (May-October). However, we sometimes have last-minute availability." },
  { q: "What is the booking process?", a: "After your inquiry, we'll schedule a consultation call. Once you decide to book, we require a signed contract and 30% retainer to secure your date." },
  { q: "How long until we receive our photos?", a: "You'll receive sneak peeks within 48 hours. The full gallery is delivered within 4-6 weeks of your wedding date." },
  { q: "Do you travel for destination weddings?", a: "Yes! We love destination weddings. Travel fees apply for locations outside our NJ, FL, and CO service areas." },
  { q: "Can we customize our package?", a: "Absolutely. We're happy to create a custom package that fits your specific needs and budget." },
  { q: "What happens if you're sick on our wedding day?", a: "We have a network of trusted backup photographers. In the rare event of emergency, we'll ensure you're covered." },
];

const FAQ = () => (
  <>
    <Helmet>
      <title>FAQ | Pixie Clicks Wedding Photography | NJ, FL & CO</title>
      <meta
        name="description"
        content="Common questions about Pixie Clicks wedding photography, booking, pricing & delivery. Serving NJ, FL & CO."
      />
      <meta property="og:title" content="FAQ | Pixie Clicks Wedding Photography" />
      <meta property="og:description" content="Common questions about wedding photography booking, pricing, and delivery." />
      <meta property="og:type" content="website" />
      <meta property="og:url" content="https://pixieclicks.com/faq" />
      <link rel="canonical" href="https://pixieclicks.com/faq" />
      <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": "FAQPage",
          "mainEntity": faqs.map(faq => ({
            "@type": "Question",
            "name": faq.q,
            "acceptedAnswer": {
              "@type": "Answer",
              "text": faq.a
            }
          }))
        })}
      </script>
    </Helmet>
    <Layout>
      <section className="section-padding">
        <div className="container-narrow">
          <h1 className="font-serif text-4xl font-semibold text-foreground text-center md:text-5xl">Frequently Asked <span className="text-primary">Questions</span></h1>
          <Accordion type="single" collapsible className="mt-12">
            {faqs.map((faq, i) => (
              <AccordionItem key={i} value={`item-${i}`}>
                <AccordionTrigger className="text-left font-medium">{faq.q}</AccordionTrigger>
                <AccordionContent className="text-muted-foreground">{faq.a}</AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </section>
    </Layout>
  </>
);

export default FAQ;
